import { render, staticRenderFns } from "./SellerComissionFormView.vue?vue&type=template&id=182924f0&scoped=true"
import script from "./SellerComissionFormView.vue?vue&type=script&lang=js"
export * from "./SellerComissionFormView.vue?vue&type=script&lang=js"
import style0 from "./SellerComissionFormView.vue?vue&type=style&index=0&id=182924f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182924f0",
  null
  
)

export default component.exports